import React from "react"
import { ErrorObject } from "ajv"
import { IconWarn } from "dash-styled"

interface ErrorsProps {
    errors: ErrorObject[]
    showDataPath?: boolean
    className?: string
}

export const Errors = ({
    errors,
    className,
    showDataPath = false
}: ErrorsProps) => {
    if (errors.length === 0) {
        return null
    }

    const message = errors[0].message || "Invalid input"
    const dataPath = errors[0].dataPath

    return (
        <div className={`py-2 flex ${className}`} style={{ color: "#b91c1c" }}>
            <IconWarn className="mr-2 flex-shrink-0" />
            <span>
                The value {message}
                {showDataPath && dataPath ? (
                    <>
                        {" "}
                        at JSON path{" "}
                        <span className="rounded bg-coral-200 p-1 font-mono text-xs">
                            {dataPath}
                        </span>
                    </>
                ) : (
                    ""
                )}
            </span>
        </div>
    )
}
